<template>
    <div class="tuka-modal" ref="modal">
        <div class="tuka-modal__header">
            <button class="tuka-modal__button" @click="$modal.close()">
              <span aria-hidden="true">X</span>
              <span class="sr-only">{{ $t('tuka.modal.close') }}</span>
            </button>
        </div>
        <div class="tuka-modal__content">
          <figure>
            <figcaption v-if="figcaption !== ''" class="mb-3" v-html="figcaption"></figcaption>
            <img ref="modalImage" :src="image.src" :alt="image.alt" :title="image.title" />
          </figure>
        </div>
    </div>
</template>
<script>
export default {
  name: "ImageModal",
  props: ['image','figcaption','isVisible'],
  data() {
    return{}
  },
  watch: {
    isVisible: {
      immediate: true,
      handler(val, oldV) {

        // Add little timeout to get element width & height
        // Check is modal wider or taller and add correct css-classes
        // add give height for image
        setTimeout(() => {
          const isWider = window.innerWidth > window.innerHeight ? true : false;
          let height = window.innerHeight;

          if (this.figcaption !== "") {
            let caption = this.$refs.modal.querySelector('figcaption')
            height = height - ( caption.offsetHeight + 40 );
          }

          if (isWider) {
            this.$refs.modalImage.classList.add('modal-image--wide');
            // Set height of image
            this.$refs.modalImage.style.height = Math.floor( height * .85 ) + 'px';

            if (window.innerWidth < this.$refs.modalImage.clientWidth) {
              this.$refs.modalImage.style.height = "";
              this.$refs.modalImage.style.width = "100%";
            }
          } else {
            this.$refs.modalImage.style.height = "";
            this.$refs.modalImage.classList.add('modal-image--tall');
          }
        },10)
      }
    }
  },
  mounted() {
    const modal = document.querySelector('.v-modal');
    if (modal) {
      const body = document.querySelector('body');
      body.appendChild(modal);
    }
  }
}
</script>
